import { render, staticRenderFns } from "./DownloadCO.vue?vue&type=template&id=b5141298&"
import script from "./DownloadCO.vue?vue&type=script&lang=js&"
export * from "./DownloadCO.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCO.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports